import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0063628"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-6 text--center" }

import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPassword',
  props: {
  isPinTimeOver: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:password', 'goToLogin', 'submit'],
  setup(__props, { emit }) {

const props = __props;





const password = ref('');
const passwordConfirm = ref('');

const hasPasswordError = computed(() => Boolean(passwordConfirm.value && !password.value));
const hasPasswordConfirmError = computed(() =>
  Boolean(password.value && passwordConfirm.value && passwordConfirm.value !== password.value),
);

const isRestoreFailed = computed(() => props.isPinTimeOver || hasPasswordError.value || hasPasswordConfirmError.value);
const errorMessage = computed(() => {
  if (props.isPinTimeOver) {
    return 'Срок действия ссылки истек';
  }
  if (passwordConfirm.value && !password.value) {
    return 'Пароль не может быть пустым';
  }
  return 'Пароль и подтверждение должны совпадать';
});

const isSubmitDisabled = computed(() => !(password.value && passwordConfirm.value === password.value));

const updatePassword = () => emit('update:password', password.value);
const goToLogin = () => emit('goToLogin');
const submit = () => {
  if (password.value && passwordConfirm.value === password.value) {
    emit('submit', password.value);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiInput, {
      modelValue: password.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
        updatePassword
      ],
      placeholder: "Новый пароль",
      type: "password",
      size: "large",
      disabled: __props.isPinTimeOver,
      error: _unref(hasPasswordError)
    }, null, 8, ["modelValue", "disabled", "error"]),
    _createVNode(_component_UiInput, {
      modelValue: passwordConfirm.value,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => ((passwordConfirm).value = $event)),
        updatePassword
      ],
      class: "mt-4",
      placeholder: "Подтвердить новый пароль",
      type: "password",
      size: "large",
      disabled: __props.isPinTimeOver,
      error: _unref(hasPasswordConfirmError),
      onPressEnter: submit
    }, null, 8, ["modelValue", "disabled", "error"]),
    _createVNode(_component_UiButton, {
      class: "button-submit mt-4",
      type: "primary",
      size: "large",
      disabled: _unref(isSubmitDisabled),
      onClick: submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Создать новый пароль ")
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createElementVNode("p", {
      class: _normalizeClass(["auth-view--error text--small text--center error--text mt-2 error-message", { active: _unref(isRestoreFailed) }])
    }, _toDisplayString(_unref(errorMessage)), 3),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_UiButton, {
        type: "link",
        size: "large",
        onClick: _withModifiers(goToLogin, ["prevent","stop"])
      }, {
        default: _withCtx(() => [
          _createTextVNode("На страницу входа")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
}

})